export enum TerpeneUnitOfMeasure {
  Percent = '%',
  MilliGram = 'mg',
  MilliGramPerGram = 'mg/g',
  MilliGramPerMilliLitre = 'mg/ml',
  NA = 'N/A',
  UNKNOWN = ''
}
